import React from "react";
import listitemCSS from "./ListItem.module.css"


function ListItem({ icon, title, selected }) {
    return (
        <div>
            {selected?<span className={listitemCSS.li_highlighted}>{icon == '' ? '' : <img src={icon}></img>}{title}</span>:<span className={listitemCSS.li}>{icon == '' ? '' : <img src={icon}></img>}{title}</span>}
            <span className={listitemCSS.lis}></span>
        </div>

    )
}

export default ListItem;
